import { render, staticRenderFns } from "./MediaPopup.vue?vue&type=template&id=6de45990&scoped=true&"
import script from "./MediaPopup.vue?vue&type=script&lang=js&"
export * from "./MediaPopup.vue?vue&type=script&lang=js&"
import style0 from "./MediaPopup.vue?vue&type=style&index=0&id=6de45990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de45990",
  null
  
)

export default component.exports